<template>
    <form
        method="post"
        autocomplete="off"
        enctype="multipart/form-data"
        @submit.prevent="addorUpdateMaterialFolder"
    >
        <div class="row pt-2">
            <div class="col-sm-12 col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="title"
                        >Title</label
                    >
                    <input
                        type="text"
                        name="title"
                        v-model="form.title"
                        class="form-control"
                        placeholder="Title"
                        required
                        autofocus
                    />
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-sm-12 col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="title"
                        >Order</label
                    >
                    <input
                        type="number"
                        name="title"
                        v-model="form.order"
                        class="form-control"
                        placeholder="Order"
                        autofocus
                    />
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col-sm-12 col-md-12">
                <div class="form-group">
                    <label class="form-control-label text-muted" for="thumbnail"
                        >Thumbnail</label
                    >
                    <input
                        type="file"
                        name="thumbnail"
                        @change="onChangeThumbnail"
                        class="form-control"
                        accept=".jpg,.jpeg,.png"
                        autofocus
                    />
                    <div class="preview-container mt-4" v-if="thumbnail.length">
                        <div
                            v-for="file in thumbnail"
                            :key="file.name"
                            class="preview-card"
                        >
                            <img
                                class="preview-img2"
                                :src="generateURL(file)"
                            />
                        </div>
                    </div>
                    <div class="preview-container mt-4" v-else>
                        <div v-if="modalType == 'edit'" class="preview-card">
                            <img class="preview-img2" :src="thumbnailTemp" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button
            type="submit"
            class="mt-5 btn btn-outline-orange text-orange text-uppercase float-right"
        >
            {{ modalType == "edit" ? "Update Folder" : "Add Folder" }}
        </button>
    </form>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
    props: ["modalType", "modalData"],
    emits: ["closeModal"],
    components: {},
    setup() {
        const store = useStore();
        return {
            store,
        };
    },
    data() {
        return {
            form: {
                id: null,
                title: null,
                order: 0,
            },
            isDragging: false,
            files: [],
            thumbnail: [],
            thumbnailTemp: "",
            fileTemp: "",
        };
    },
    mounted() {
        this.clearFields();
        if (this.modalType == "edit") {
            this.populateData();
        }
    },
    methods: {
        onChangeThumbnail(e) {
            this.thumbnail = e.target.files;
            // console.log('this.thumbnail', this.thumbnail)
        },
        onChange(e) {
            this.files = e.target.files;
            // console.log('this.files', this.files)
        },
        generateURL(file) {
            let fileSrc = URL.createObjectURL(file);
            setTimeout(() => {
                URL.revokeObjectURL(fileSrc);
            }, 1000);
            return fileSrc;
        },
        addorUpdateMaterialFolder() {
            if (this.modalType == "add") {
                this.form.id = null;

                var newFiles = [];
                if (this.thumbnail.length > 0) {
                    newFiles.push(this.thumbnail[0]);
                }

                console.log(newFiles);

                let requestData = {
                    name: this.form.title,
                    order: this.form.order,
                };

                axios
                    .post("/api/store-material-folder", requestData)
                    .then((response) => {
                        let materialFolderId = response.data.material_folder_id;

                        if (newFiles.length > 0) {
                            newFiles.forEach((data, index) => {
                                const formData = new FormData();
                                formData.append("attachments", data);
                                formData.append("id", materialFolderId);
                                formData.append(
                                    "type",
                                    index == 0 ? "image" : "attachments"
                                );

                                axios
                                    .post(
                                        "/api/upload-file-material-folder",
                                        formData
                                    )
                                    .then((response) => {
                                        this.store.dispatch(
                                            "material/getAllMaterialFolders"
                                        );
                                    });
                            });
                        } else {
                            this.store.dispatch(
                                "material/getAllMaterialFolders"
                            );
                        }
                    });
            } else {
                // this.updateMaterial(this.form);

                let requestData = {
                    id: this.form.id,
                    name: this.form.title,
                    order: this.form.order,
                };

                axios
                    .post("/api/update-material-folder", requestData)
                    .then((response) => {
                        let materialId = response.data.material_folder_id;

                        if (this.thumbnail.length > 0) {
                            const formData = new FormData();
                            formData.append("attachments", this.thumbnail[0]);
                            formData.append("id", materialId);
                            formData.append("type", "image");

                            axios
                                .post(
                                    "/api/upload-file-material-folder",
                                    formData
                                )
                                .then((response) => {
                                    this.store.dispatch(
                                        "material/getAllMaterialFolders"
                                    );
                                });
                        } else {
                            this.store.dispatch(
                                "material/getAllMaterialFolders"
                            );
                        }
                    });
            }
            this.$emit("closeModal");
        },
        populateData() {
            this.form.id = this.modalData.id;
            this.form.title = this.modalData.name;
            this.form.order = this.modalData.order;
            this.thumbnailTemp = this.modalData.image;
        },
        clearFields() {
            this.form.id = null;
            this.form.title = null;
            this.thumbnail = [];
            this.files = [];
            this.thumbnailTemp = "";
            this.fileTemp = "";
        },
    },
};
</script>
